//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import VipTimeline from './_vip_timeline'
import HouseAttachs from './_house_attachs'

export default {
    props: {
        is_talent_progress: Boolean,
        select_house_progress_tab: String,
        house_progress_tabs: Array,
        current_house: Object,
        house: Object
    },
    components: {
        HouseAttachs,
        VipTimeline
    },
    methods: {
        tabLog(e) {
            this.$emit('tabLog', e)
        },
        changeType(e) {
            this.$emit('changeHouseProgressType', e)
        },
        goTalent(e) {
            this.$emit('goTalent', e)
        }
    }
}
